import { useEffect } from 'react';
import { useThemeData } from '@msrceng/theme';
import { useMySettingsApi } from '../../api';
/**
 * Effect that sets the theme from the API
 */
export const useEffectSetThemeFromApi = () => {
    const { data, isLoading } = useMySettingsApi();
    const { themeKey, setTheme } = useThemeData();
    const themeFromProfile = data === null || data === void 0 ? void 0 : data.theme;
    useEffect(() => {
        if (themeFromProfile && themeFromProfile !== themeKey && !isLoading) {
            setTheme(themeFromProfile);
        }
    }, [themeFromProfile, themeKey, isLoading, setTheme]);
};
